import { useEffect,useState } from 'react';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import { toast } from 'react-toastify';
import ReactSelect from 'react-select';

const Import = () => {

    const [branchId,setBranchId] = useState('');
    const [branches,setBranches] = useState([]);
    const [childrenFile,setChildrenFile] = useState('');
    const {readData: getBranchesData} = useEntityCrud('Branch/GetAllBranchs');
    const {addData: addChildren} = useEntityCrud('User/uploadDependentPeople');

    useEffect(() => {
        const postedData = {
            offset: 0,
            limit: 1000
        }
        getBranchesData(postedData).then(({data}) => {
            if(data.status){
                const result = data.result.map(i => ({label: i.title, value: i.id}));
                setBranches(result);
            }
        })
    },[])

    const toBase64 = async file => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }

    const changeFile = async e => {
        const file = e.target.files[0];
        const fileData = await toBase64(file);
        setChildrenFile(fileData);
    }

    const importFile = () => {
        document.getElementById('btn-submit-form').classList.add('btn-loading');
        const postedData = {
            companyId: branchId,
            file: childrenFile
        }
        addChildren(postedData).then(({data}) => {
            if(data.status){
                setChildrenFile('');
                setBranchId('');
                toast.success('لیست فرزندان با موفقیت درون ریزی شد');
            }else
                data.errors.map(error => toast.error(error.message));
        }).finally(() => document.getElementById('btn-submit-form').classList.remove('btn-loading'));
    }

    const dowmloadSample = () => {
        
    }

    return (
        <div className="card">
            <div className="card-header">
                <div className="card-title">درون ریزی لیست فرزندان از طریق فایل</div>
            </div>
            <div className="card-body">
                <div className="row">
                    <div className="col-md-3">
                        <div className="form-group">
                            <label>شرکت</label>
                            <ReactSelect noOptionsMessage={(e) => "یافت نشد"} placeholder="انتخاب کنید" options={branches} value={branches.filter((b) => b.value == branchId)} onChange={(e) => setBranchId(e.value)} />
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <label>فایل</label>
                            <input type="file" className="form-control" onChange={e => changeFile(e)} />
                        </div>
                    </div>
                    <div className="col-md-2">
                        <button id="btn-submit-form" className="btn btn-success" onClick={importFile} style={{marginTop: 29}}>درون ریزی</button>
                    </div>
                </div>
                <a target="_blank" href="/children-sample.xlsx" onClick={dowmloadSample} style={{marginTop: 29}}>دریافت فایل نمونه</a>
            </div>
        </div>
    )
}

export default Import;